import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/store";
import {
  setImageCapturingMode,
  setStreamingMode,
  setReadyToSubmitReport,
} from "src/store/inspectionCaptureSlice";
import { updateInspectionResults } from "src/store/inspectionResultsSlice";

/**
 * Custom hook to manage inspection workflow state transitions
 * Handles navigation between questions and submission flow
 */
export const useInspectionFlow = () => {
  const dispatch = useAppDispatch();
  const { doneInspectingCurrentQuestion } = useAppSelector(
    (state) => state.inspectionCapture
  );
  const { inspectionResult } = useAppSelector(
    (state) => state.inspectionResults
  );

  // Enhanced effect to ensure proper transition to submit report page
  useEffect(() => {
    if (doneInspectingCurrentQuestion) {
      dispatch(setImageCapturingMode(false));
      dispatch(setStreamingMode(false));
      dispatch(setReadyToSubmitReport(true));

      // Force UI update to ensure parent component detects the state change
      setTimeout(() => {
        if (doneInspectingCurrentQuestion) {
          dispatch(setReadyToSubmitReport(true));
        }
      }, 100);
    }
  }, [doneInspectingCurrentQuestion, dispatch]);

  // Update inspection results when inspection result changes
  useEffect(() => {
    if (inspectionResult.questionId) {
      dispatch(updateInspectionResults(inspectionResult));
    }
  }, [inspectionResult, dispatch]);
};
